import { object, SchemaOf, string } from 'yup';

import { FeedbackModalFormTypes } from './types';

export const useFeedbackModalSchema = () =>
  object().shape({
    reason: string().required(''),
    feedback: string().optional(),
  }) as unknown as SchemaOf<FeedbackModalFormTypes>;
